import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, useMediaQueryContext } from '@fourthwall/components';
import { reverse, routing } from '@utils/routing';
import { useOfferBundleCreationMutation } from './useOfferBundleCreationMutation';
export const CreateBundleProductButton = ({ onSuccess }) => {
    const navigate = useNavigate();
    const { tablet } = useMediaQueryContext();
    const { offerBundleCreationMutation } = useOfferBundleCreationMutation({
        onSuccess: ({ id }) => {
            onSuccess();
            navigate(`${reverse(routing.products.bundle.bundleId.self, { bundleId: id })}${location.search}`);
        },
    });
    return (React.createElement(Button, { fullWidth: !tablet, label: "Create bundle product", loading: offerBundleCreationMutation.isLoading || offerBundleCreationMutation.isSuccess, disabled: offerBundleCreationMutation.isLoading || offerBundleCreationMutation.isSuccess, size: "xsmall", onClick: async () => {
            await offerBundleCreationMutation.mutateAsync([]);
        } }));
};
